import React from 'react';
import { useInput, useTranslate } from 'react-admin';
import lodashGet from 'lodash/get';

import { CurrencyAutocomplete } from '~/components';
import { useHandbook } from '~/hooks';
import { useTenantCurrencies } from '~/hooks/tenant';

export interface Props {
  source: string;
  record?: any;
  label?: string;
  solutionId?: string;
  allChoices?: boolean;
  selectedValue?: string;
  [k: string]: any;
}

interface CurrencyOption {
  id: string;
  name: string;
}

const CurrencySelect = ({ solutionId, record, source, onChange, allChoices, ...rest }: Props) => {
  const { data } = useHandbook(solutionId);
  const { data: tenantCurrencies } = useTenantCurrencies();
  const translate = useTranslate();

  const {
    input: { value: inputValue, onChange: onChangeLocal },
    meta: { touched, error },
    isRequired,
  } = useInput({
    source,
    ...rest,
  });

  const value = inputValue || (record && lodashGet(record, source)) || null;

  if (solutionId !== undefined) {
    if (data) {
      const currencies = (data?.currencies || [])
        .map((currency) => {
          return { id: currency.id, name: currency.id };
        })
        .sort((a: CurrencyOption, b: CurrencyOption) => {
          return a.id.localeCompare(b.id);
        });
      return (
        <CurrencyAutocomplete
          {...rest}
          label={translate(rest.label || source)}
          value={value}
          onChange={(e) => {
            onChangeLocal(e.target.value);
            if (onChange) {
              onChange(e);
            }
          }}
          options={currencies.map((c) => c.id)}
          required={isRequired}
          error={touched && !!error}
          helperText={touched && error ? translate(error) : '\u0020'}
        />
      );
    } else {
      return (
        <CurrencyAutocomplete
          {...rest}
          value={null}
          label={translate(rest.label || source)}
          disabled
          options={[]}
          required={isRequired}
          helperText={touched && error ? translate(error) : '\u0020'}
        />
      );
    }
  } else {
    return (
      <CurrencyAutocomplete
        {...rest}
        label={translate(rest.label || source)}
        value={value}
        onChange={(e) => {
          onChangeLocal(e.target.value);
          if (onChange) {
            onChange(e);
          }
        }}
        options={allChoices ? undefined : tenantCurrencies?.map((c) => c.code) || []}
        required={isRequired}
        error={touched && !!error}
        helperText={touched && error ? translate(error) : '\u0020'}
      />
    );
  }
};

export default CurrencySelect;
